/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class QueryOperator {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return QueryOperator.fixupPrototype; }

    static newInstance(model: Partial<QueryOperator>): QueryOperator {
        let obj = Object.assign(new QueryOperator(), model);
        QueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<QueryOperator>): QueryOperator {
        if (!model) return null;
        return QueryOperator.newInstance(<QueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: QueryOperator) {
        if (!obj) return;

        models.QueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: QueryOperator): boolean {
        switch (obj.__type)
        {
            case "AIAgentAttributesQueryOperator":
                Object.setPrototypeOf(obj, models.AIAgentAttributesQueryOperator.prototype);
                break;
            case "AIProviderQueryOperator":
                Object.setPrototypeOf(obj, models.AIProviderQueryOperator.prototype);
                break;
            case "AppSecopsApplicationIdQueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsApplicationIdQueryOperator.prototype);
                break;
            case "AppSecopsComponentProductQueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsComponentProductQueryOperator.prototype);
                break;
            case "AppSecopsContainerFindingsCategoryQueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsContainerFindingsCategoryQueryOperator.prototype);
                break;
            case "AppSecopsContainerFindingsExecutionPhaseQueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsContainerFindingsExecutionPhaseQueryOperator.prototype);
                break;
            case "AppSecopsContainerFindingsSBOMVersionIdsQueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsContainerFindingsSBOMVersionIdsQueryOperator.prototype);
                break;
            case "AppSecopsContainerFindingsSeverityQueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsContainerFindingsSeverityQueryOperator.prototype);
                break;
            case "AppSecopsContainerFindingsStatusQueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsContainerFindingsStatusQueryOperator.prototype);
                break;
            case "AppSecopsCveIdQueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsCveIdQueryOperator.prototype);
                break;
            case "AppSecopsCvssScoreQueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsCvssScoreQueryOperator.prototype);
                break;
            case "AppSecopsEpssScoreQueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsEpssScoreQueryOperator.prototype);
                break;
            case "AppSecopsFixAvailableQueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsFixAvailableQueryOperator.prototype);
                break;
            case "AppSecopsGraphionScoreQueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsGraphionScoreQueryOperator.prototype);
                break;
            case "AppSecopsIsKnownExploitedVulnerabilityQueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsIsKnownExploitedVulnerabilityQueryOperator.prototype);
                break;
            case "AppSecopsPortfolioIdQueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsPortfolioIdQueryOperator.prototype);
                break;
            case "AppSecopsProjectIdQueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsProjectIdQueryOperator.prototype);
                break;
            case "AppSecopsSbomComponentIdQueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsSbomComponentIdQueryOperator.prototype);
                break;
            case "AppSecopsSbomComponentTypeQueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsSbomComponentTypeQueryOperator.prototype);
                break;
            case "AppSecopsSbomNameQueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsSbomNameQueryOperator.prototype);
                break;
            case "AppSecopsSbomVersionBuildIdQueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsSbomVersionBuildIdQueryOperator.prototype);
                break;
            case "AppSecopsSbomVersionIdQueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsSbomVersionIdQueryOperator.prototype);
                break;
            case "AppSecopsSbomVersionSubmittedByQueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsSbomVersionSubmittedByQueryOperator.prototype);
                break;
            case "AppSecopsSbomVersionSubmittedDateQueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsSbomVersionSubmittedDateQueryOperator.prototype);
                break;
            case "AppSecopsVulnerabilityExploitabilityMetricAttackComplexityV31QueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsVulnerabilityExploitabilityMetricAttackComplexityV31QueryOperator.prototype);
                break;
            case "AppSecopsVulnerabilityExploitabilityMetricAttackVectorV31QueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsVulnerabilityExploitabilityMetricAttackVectorV31QueryOperator.prototype);
                break;
            case "AppSecopsVulnerabilityExploitabilityMetricPrivilegesRequiredV31QueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsVulnerabilityExploitabilityMetricPrivilegesRequiredV31QueryOperator.prototype);
                break;
            case "AppSecopsVulnerabilityExploitabilityMetricScopeV31QueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsVulnerabilityExploitabilityMetricScopeV31QueryOperator.prototype);
                break;
            case "AppSecopsVulnerabilityExploitabilityUserInteractionV31QueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsVulnerabilityExploitabilityUserInteractionV31QueryOperator.prototype);
                break;
            case "AppSecopsVulnerabilityImpactMetricAvailabilityImpactV31QueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsVulnerabilityImpactMetricAvailabilityImpactV31QueryOperator.prototype);
                break;
            case "AppSecopsVulnerabilityImpactMetricConfidentialityImpactV31QueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsVulnerabilityImpactMetricConfidentialityImpactV31QueryOperator.prototype);
                break;
            case "AppSecopsVulnerabilityImpactMetricIntegrityImpactV31QueryOperator":
                Object.setPrototypeOf(obj, models.AppSecopsVulnerabilityImpactMetricIntegrityImpactV31QueryOperator.prototype);
                break;
            case "ApplicableHealthMetricsQueryOperator":
                Object.setPrototypeOf(obj, models.ApplicableHealthMetricsQueryOperator.prototype);
                break;
            case "AssessmentQueryAssessmentApprover":
                Object.setPrototypeOf(obj, models.AssessmentQueryAssessmentApprover.prototype);
                break;
            case "AssessmentQueryAssessmentName":
                Object.setPrototypeOf(obj, models.AssessmentQueryAssessmentName.prototype);
                break;
            case "AssessmentQueryAssessmentOwner":
                Object.setPrototypeOf(obj, models.AssessmentQueryAssessmentOwner.prototype);
                break;
            case "AssessmentQueryFramework":
                Object.setPrototypeOf(obj, models.AssessmentQueryFramework.prototype);
                break;
            case "AssessmentQueryPillar":
                Object.setPrototypeOf(obj, models.AssessmentQueryPillar.prototype);
                break;
            case "AssessmentQueryWorkload":
                Object.setPrototypeOf(obj, models.AssessmentQueryWorkload.prototype);
                break;
            case "AssessmentReportQueryAssessmentName":
                Object.setPrototypeOf(obj, models.AssessmentReportQueryAssessmentName.prototype);
                break;
            case "AssessmentReportQueryFramework":
                Object.setPrototypeOf(obj, models.AssessmentReportQueryFramework.prototype);
                break;
            case "AssessmentReportQueryReportType":
                Object.setPrototypeOf(obj, models.AssessmentReportQueryReportType.prototype);
                break;
            case "AssessmentReportQueryWorkloadId":
                Object.setPrototypeOf(obj, models.AssessmentReportQueryWorkloadId.prototype);
                break;
            case "AssessmentRunReportDetailQuerySection":
                Object.setPrototypeOf(obj, models.AssessmentRunReportDetailQuerySection.prototype);
                break;
            case "AssessmentRunReportSummaryQuerySection":
                Object.setPrototypeOf(obj, models.AssessmentRunReportSummaryQuerySection.prototype);
                break;
            case "AssessmentViewQueryAssignedTo":
                Object.setPrototypeOf(obj, models.AssessmentViewQueryAssignedTo.prototype);
                break;
            case "AssessmentViewQueryBestPracticeRisk":
                Object.setPrototypeOf(obj, models.AssessmentViewQueryBestPracticeRisk.prototype);
                break;
            case "AssessmentViewQueryBestPracticeStatus":
                Object.setPrototypeOf(obj, models.AssessmentViewQueryBestPracticeStatus.prototype);
                break;
            case "AssessmentViewQueryComment":
                Object.setPrototypeOf(obj, models.AssessmentViewQueryComment.prototype);
                break;
            case "AssessmentViewQueryNature":
                Object.setPrototypeOf(obj, models.AssessmentViewQueryNature.prototype);
                break;
            case "AssessmentViewQueryOwner":
                Object.setPrototypeOf(obj, models.AssessmentViewQueryOwner.prototype);
                break;
            case "AssessmentViewQueryQuestionRisk":
                Object.setPrototypeOf(obj, models.AssessmentViewQueryQuestionRisk.prototype);
                break;
            case "AssessmentViewQueryQuestionStatus":
                Object.setPrototypeOf(obj, models.AssessmentViewQueryQuestionStatus.prototype);
                break;
            case "AutomationTemplateQueryClassification":
                Object.setPrototypeOf(obj, models.AutomationTemplateQueryClassification.prototype);
                break;
            case "AutomationTemplateQueryEngineType":
                Object.setPrototypeOf(obj, models.AutomationTemplateQueryEngineType.prototype);
                break;
            case "AutomationTemplateQueryEngineTypes":
                Object.setPrototypeOf(obj, models.AutomationTemplateQueryEngineTypes.prototype);
                break;
            case "AutomationTemplateQueryProvider":
                Object.setPrototypeOf(obj, models.AutomationTemplateQueryProvider.prototype);
                break;
            case "AutomationTemplateQueryRepoType":
                Object.setPrototypeOf(obj, models.AutomationTemplateQueryRepoType.prototype);
                break;
            case "AutomationTemplateQueryResourceType":
                Object.setPrototypeOf(obj, models.AutomationTemplateQueryResourceType.prototype);
                break;
            case "AutomationTemplateQueryScope":
                Object.setPrototypeOf(obj, models.AutomationTemplateQueryScope.prototype);
                break;
            case "AutomationTemplateQueryService":
                Object.setPrototypeOf(obj, models.AutomationTemplateQueryService.prototype);
                break;
            case "AutomationTemplateQuerySubClassification":
                Object.setPrototypeOf(obj, models.AutomationTemplateQuerySubClassification.prototype);
                break;
            case "AutomationTemplateQueryTemplateType":
                Object.setPrototypeOf(obj, models.AutomationTemplateQueryTemplateType.prototype);
                break;
            case "AutomationTemplateQueryTenant":
                Object.setPrototypeOf(obj, models.AutomationTemplateQueryTenant.prototype);
                break;
            case "AvailabilityZoneQueryOperator":
                Object.setPrototypeOf(obj, models.AvailabilityZoneQueryOperator.prototype);
                break;
            case "AwsSecurityHubFindingQueryCloudAccount":
                Object.setPrototypeOf(obj, models.AwsSecurityHubFindingQueryCloudAccount.prototype);
                break;
            case "AwsSecurityHubFindingQueryLocation":
                Object.setPrototypeOf(obj, models.AwsSecurityHubFindingQueryLocation.prototype);
                break;
            case "AwsSecurityHubFindingQueryProductName":
                Object.setPrototypeOf(obj, models.AwsSecurityHubFindingQueryProductName.prototype);
                break;
            case "AwsSecurityHubFindingQueryRecordState":
                Object.setPrototypeOf(obj, models.AwsSecurityHubFindingQueryRecordState.prototype);
                break;
            case "AwsSecurityHubFindingQueryResource":
                Object.setPrototypeOf(obj, models.AwsSecurityHubFindingQueryResource.prototype);
                break;
            case "AwsSecurityHubFindingQuerySeverity":
                Object.setPrototypeOf(obj, models.AwsSecurityHubFindingQuerySeverity.prototype);
                break;
            case "AwsSsmDocumentQueryCategory":
                Object.setPrototypeOf(obj, models.AwsSsmDocumentQueryCategory.prototype);
                break;
            case "AwsSsmDocumentQueryCloudAccount":
                Object.setPrototypeOf(obj, models.AwsSsmDocumentQueryCloudAccount.prototype);
                break;
            case "AwsSsmDocumentQueryExecutedBy":
                Object.setPrototypeOf(obj, models.AwsSsmDocumentQueryExecutedBy.prototype);
                break;
            case "AwsSsmDocumentQueryName":
                Object.setPrototypeOf(obj, models.AwsSsmDocumentQueryName.prototype);
                break;
            case "AwsSsmDocumentQueryOwner":
                Object.setPrototypeOf(obj, models.AwsSsmDocumentQueryOwner.prototype);
                break;
            case "AwsSsmDocumentQueryRegion":
                Object.setPrototypeOf(obj, models.AwsSsmDocumentQueryRegion.prototype);
                break;
            case "AwsSsmDocumentQueryStatus":
                Object.setPrototypeOf(obj, models.AwsSsmDocumentQueryStatus.prototype);
                break;
            case "BillingEntityQueryOperator":
                Object.setPrototypeOf(obj, models.BillingEntityQueryOperator.prototype);
                break;
            case "BillingEntityRegexQueryOperator":
                Object.setPrototypeOf(obj, models.BillingEntityRegexQueryOperator.prototype);
                break;
            case "BillingLineItemTypeQueryOperator":
                Object.setPrototypeOf(obj, models.BillingLineItemTypeQueryOperator.prototype);
                break;
            case "BillingLineItemTypeRegexQueryOperator":
                Object.setPrototypeOf(obj, models.BillingLineItemTypeRegexQueryOperator.prototype);
                break;
            case "BillingSourceQueryOperator":
                Object.setPrototypeOf(obj, models.BillingSourceQueryOperator.prototype);
                break;
            case "CompartmentNameQueryOperator":
                Object.setPrototypeOf(obj, models.CompartmentNameQueryOperator.prototype);
                break;
            case "CompartmentPathQueryOperator":
                Object.setPrototypeOf(obj, models.CompartmentPathQueryOperator.prototype);
                break;
            case "ComplianceAssessmentDetailStatusQueryOperator":
                Object.setPrototypeOf(obj, models.ComplianceAssessmentDetailStatusQueryOperator.prototype);
                break;
            case "ComplianceAssessmentHistoryExecutionTypeQueryOperator":
                Object.setPrototypeOf(obj, models.ComplianceAssessmentHistoryExecutionTypeQueryOperator.prototype);
                break;
            case "ComplianceAssessmentHistoryStatusQueryOperator":
                Object.setPrototypeOf(obj, models.ComplianceAssessmentHistoryStatusQueryOperator.prototype);
                break;
            case "ComplianceControlFamilyQueryOperator":
                Object.setPrototypeOf(obj, models.ComplianceControlFamilyQueryOperator.prototype);
                break;
            case "ComplianceControlNatureQueryOperator":
                Object.setPrototypeOf(obj, models.ComplianceControlNatureQueryOperator.prototype);
                break;
            case "ComplianceControlPolicyUris":
                Object.setPrototypeOf(obj, models.ComplianceControlPolicyUris.prototype);
                break;
            case "ComplianceControlSeverityQueryOperator":
                Object.setPrototypeOf(obj, models.ComplianceControlSeverityQueryOperator.prototype);
                break;
            case "ComplianceControlSubFamilyQueryOperator":
                Object.setPrototypeOf(obj, models.ComplianceControlSubFamilyQueryOperator.prototype);
                break;
            case "ComplianceStandardIDQueryOperator":
                Object.setPrototypeOf(obj, models.ComplianceStandardIDQueryOperator.prototype);
                break;
            case "ComplianceStandardScopeQueryOperator":
                Object.setPrototypeOf(obj, models.ComplianceStandardScopeQueryOperator.prototype);
                break;
            case "ComplianceURIQueryOperator":
                Object.setPrototypeOf(obj, models.ComplianceURIQueryOperator.prototype);
                break;
            case "ContainerIdRegexQueryOperator":
                Object.setPrototypeOf(obj, models.ContainerIdRegexQueryOperator.prototype);
                break;
            case "CostAnomalyStatusQueryOperator":
                Object.setPrototypeOf(obj, models.CostAnomalyStatusQueryOperator.prototype);
                break;
            case "CurrencyExchangeConfigurationQueryScope":
                Object.setPrototypeOf(obj, models.CurrencyExchangeConfigurationQueryScope.prototype);
                break;
            case "CurrencyExchangeConfigurationQuerySourceCurrency":
                Object.setPrototypeOf(obj, models.CurrencyExchangeConfigurationQuerySourceCurrency.prototype);
                break;
            case "CurrencyExchangeConfigurationQueryTargetCurrency":
                Object.setPrototypeOf(obj, models.CurrencyExchangeConfigurationQueryTargetCurrency.prototype);
                break;
            case "CurrencyQueryOperator":
                Object.setPrototypeOf(obj, models.CurrencyQueryOperator.prototype);
                break;
            case "CvssMetricScoreRangeQueryOperator":
                Object.setPrototypeOf(obj, models.CvssMetricScoreRangeQueryOperator.prototype);
                break;
            case "DescendantServiceAccountInTenantQueryOperator":
                Object.setPrototypeOf(obj, models.DescendantServiceAccountInTenantQueryOperator.prototype);
                break;
            case "DescendantServiceAccountQueryOperator":
                Object.setPrototypeOf(obj, models.DescendantServiceAccountQueryOperator.prototype);
                break;
            case "DimensionQueryOperator":
                Object.setPrototypeOf(obj, models.DimensionQueryOperator.prototype);
                break;
            case "DimensionSourceQueryOperator":
                Object.setPrototypeOf(obj, models.DimensionSourceQueryOperator.prototype);
                break;
            case "DurationInMonthsQueryOperator":
                Object.setPrototypeOf(obj, models.DurationInMonthsQueryOperator.prototype);
                break;
            case "EpssScoreRangeQueryOperator":
                Object.setPrototypeOf(obj, models.EpssScoreRangeQueryOperator.prototype);
                break;
            case "EventCreationTimeRangeQueryOperator":
                Object.setPrototypeOf(obj, models.EventCreationTimeRangeQueryOperator.prototype);
                break;
            case "ExtrasValueRegexQueryOperator":
                Object.setPrototypeOf(obj, models.ExtrasValueRegexQueryOperator.prototype);
                break;
            case "GraphionScoreRangeQueryOperator":
                Object.setPrototypeOf(obj, models.GraphionScoreRangeQueryOperator.prototype);
                break;
            case "InfraResourceTrendResourceChangeStatusQueryOperator":
                Object.setPrototypeOf(obj, models.InfraResourceTrendResourceChangeStatusQueryOperator.prototype);
                break;
            case "InfraVulnerabilityAWSInspectorEcrImageArchitectureQueryOperator":
                Object.setPrototypeOf(obj, models.InfraVulnerabilityAWSInspectorEcrImageArchitectureQueryOperator.prototype);
                break;
            case "InfraVulnerabilityAWSInspectorEcrImageHashQueryOperator":
                Object.setPrototypeOf(obj, models.InfraVulnerabilityAWSInspectorEcrImageHashQueryOperator.prototype);
                break;
            case "InfraVulnerabilityAWSInspectorEcrImageRepositoryNameQueryOperator":
                Object.setPrototypeOf(obj, models.InfraVulnerabilityAWSInspectorEcrImageRepositoryNameQueryOperator.prototype);
                break;
            case "InfraVulnerabilityAWSInspectorEcrImageTagsQueryOperator":
                Object.setPrototypeOf(obj, models.InfraVulnerabilityAWSInspectorEcrImageTagsQueryOperator.prototype);
                break;
            case "InfraVulnerabilityAWSInspectorExploitAvailableQueryOperator":
                Object.setPrototypeOf(obj, models.InfraVulnerabilityAWSInspectorExploitAvailableQueryOperator.prototype);
                break;
            case "InfraVulnerabilityAWSInspectorFixAvailableQueryOperator":
                Object.setPrototypeOf(obj, models.InfraVulnerabilityAWSInspectorFixAvailableQueryOperator.prototype);
                break;
            case "InfraVulnerabilityAWSInspectorLambdaArchitectureQueryOperator":
                Object.setPrototypeOf(obj, models.InfraVulnerabilityAWSInspectorLambdaArchitectureQueryOperator.prototype);
                break;
            case "InfraVulnerabilityAWSInspectorLambdaFunctionNameQueryOperator":
                Object.setPrototypeOf(obj, models.InfraVulnerabilityAWSInspectorLambdaFunctionNameQueryOperator.prototype);
                break;
            case "InfraVulnerabilityAWSInspectorLambdaRuntimeQueryOperator":
                Object.setPrototypeOf(obj, models.InfraVulnerabilityAWSInspectorLambdaRuntimeQueryOperator.prototype);
                break;
            case "InfraVulnerabilityFindingsTypeQueryOperator":
                Object.setPrototypeOf(obj, models.InfraVulnerabilityFindingsTypeQueryOperator.prototype);
                break;
            case "InfraVulnerabilitySourceQueryOperator":
                Object.setPrototypeOf(obj, models.InfraVulnerabilitySourceQueryOperator.prototype);
                break;
            case "IsSystemPolicyQueryOperator":
                Object.setPrototypeOf(obj, models.IsSystemPolicyQueryOperator.prototype);
                break;
            case "LineItemDescriptionQueryOperator":
                Object.setPrototypeOf(obj, models.LineItemDescriptionQueryOperator.prototype);
                break;
            case "LineItemDescriptionRegexQueryOperator":
                Object.setPrototypeOf(obj, models.LineItemDescriptionRegexQueryOperator.prototype);
                break;
            case "LocationQueryOperator":
                Object.setPrototypeOf(obj, models.LocationQueryOperator.prototype);
                break;
            case "MasterAccountBillingQueryConversations":
                Object.setPrototypeOf(obj, models.MasterAccountBillingQueryConversations.prototype);
                break;
            case "MasterAccountBillingQueryMasterAccounts":
                Object.setPrototypeOf(obj, models.MasterAccountBillingQueryMasterAccounts.prototype);
                break;
            case "MasterAccountBillingQueryTenants":
                Object.setPrototypeOf(obj, models.MasterAccountBillingQueryTenants.prototype);
                break;
            case "MasterAccountBillingQueryTransactionType":
                Object.setPrototypeOf(obj, models.MasterAccountBillingQueryTransactionType.prototype);
                break;
            case "MasterAccountBillingQueryUsers":
                Object.setPrototypeOf(obj, models.MasterAccountBillingQueryUsers.prototype);
                break;
            case "MeterSubCategoryQueryOperator":
                Object.setPrototypeOf(obj, models.MeterSubCategoryQueryOperator.prototype);
                break;
            case "MetricNameQueryOperator":
                Object.setPrototypeOf(obj, models.MetricNameQueryOperator.prototype);
                break;
            case "MetricValuesOperator":
                Object.setPrototypeOf(obj, models.MetricValuesOperator.prototype);
                break;
            case "ModelNameQueryOperator":
                Object.setPrototypeOf(obj, models.ModelNameQueryOperator.prototype);
                break;
            case "PatchReadinessStatusQueryOperator":
                Object.setPrototypeOf(obj, models.PatchReadinessStatusQueryOperator.prototype);
                break;
            case "PlatFormAccountQueryOperator":
                Object.setPrototypeOf(obj, models.PlatFormAccountQueryOperator.prototype);
                break;
            case "PodIdRegexQueryOperator":
                Object.setPrototypeOf(obj, models.PodIdRegexQueryOperator.prototype);
                break;
            case "PodIdsQueryOperator":
                Object.setPrototypeOf(obj, models.PodIdsQueryOperator.prototype);
                break;
            case "PodNameRegexQueryOperator":
                Object.setPrototypeOf(obj, models.PodNameRegexQueryOperator.prototype);
                break;
            case "PodNamesQueryOperator":
                Object.setPrototypeOf(obj, models.PodNamesQueryOperator.prototype);
                break;
            case "PolicyCategoryQueryOperator":
                Object.setPrototypeOf(obj, models.PolicyCategoryQueryOperator.prototype);
                break;
            case "PolicyClassificationQueryOperator":
                Object.setPrototypeOf(obj, models.PolicyClassificationQueryOperator.prototype);
                break;
            case "PolicyEngineTypeQueryOperator":
                Object.setPrototypeOf(obj, models.PolicyEngineTypeQueryOperator.prototype);
                break;
            case "PolicyJobCloudProviderQueryOperator":
                Object.setPrototypeOf(obj, models.PolicyJobCloudProviderQueryOperator.prototype);
                break;
            case "PolicyJobCreatedAtQueryOperator":
                Object.setPrototypeOf(obj, models.PolicyJobCreatedAtQueryOperator.prototype);
                break;
            case "PolicyJobEngineTypeQueryOperator":
                Object.setPrototypeOf(obj, models.PolicyJobEngineTypeQueryOperator.prototype);
                break;
            case "PolicyJobExecutionGroupQueryOperator":
                Object.setPrototypeOf(obj, models.PolicyJobExecutionGroupQueryOperator.prototype);
                break;
            case "PolicyJobExecutionTypeQueryOperator":
                Object.setPrototypeOf(obj, models.PolicyJobExecutionTypeQueryOperator.prototype);
                break;
            case "PolicyJobIsArchivedQueryOperator":
                Object.setPrototypeOf(obj, models.PolicyJobIsArchivedQueryOperator.prototype);
                break;
            case "PolicyJobPolicyIdQueryOperator":
                Object.setPrototypeOf(obj, models.PolicyJobPolicyIdQueryOperator.prototype);
                break;
            case "PolicyJobStatusQueryOperator":
                Object.setPrototypeOf(obj, models.PolicyJobStatusQueryOperator.prototype);
                break;
            case "PolicyJobViolatedQueryOperator":
                Object.setPrototypeOf(obj, models.PolicyJobViolatedQueryOperator.prototype);
                break;
            case "PolicyParameterConfiguredQueryOperator":
                Object.setPrototypeOf(obj, models.PolicyParameterConfiguredQueryOperator.prototype);
                break;
            case "PolicyParameterQueryOperator":
                Object.setPrototypeOf(obj, models.PolicyParameterQueryOperator.prototype);
                break;
            case "PolicyRecommendationClassificationQueryOperator":
                Object.setPrototypeOf(obj, models.PolicyRecommendationClassificationQueryOperator.prototype);
                break;
            case "PolicyRecommendationSourceQueryOperator":
                Object.setPrototypeOf(obj, models.PolicyRecommendationSourceQueryOperator.prototype);
                break;
            case "PolicyRemediationActionEnabledQueryOperator":
                Object.setPrototypeOf(obj, models.PolicyRemediationActionEnabledQueryOperator.prototype);
                break;
            case "PolicyResourceRecommendationPolicyIdsQueryOperator":
                Object.setPrototypeOf(obj, models.PolicyResourceRecommendationPolicyIdsQueryOperator.prototype);
                break;
            case "PolicyResourceRecommendationSeverityQueryOperator":
                Object.setPrototypeOf(obj, models.PolicyResourceRecommendationSeverityQueryOperator.prototype);
                break;
            case "PolicyResourceRecommendationStatusQueryOperator":
                Object.setPrototypeOf(obj, models.PolicyResourceRecommendationStatusQueryOperator.prototype);
                break;
            case "PolicyScopeQueryOperator":
                Object.setPrototypeOf(obj, models.PolicyScopeQueryOperator.prototype);
                break;
            case "PolicyServiceQueryOperator":
                Object.setPrototypeOf(obj, models.PolicyServiceQueryOperator.prototype);
                break;
            case "PolicySeverityQueryOperator":
                Object.setPrototypeOf(obj, models.PolicySeverityQueryOperator.prototype);
                break;
            case "PolicyStatusQueryOperator":
                Object.setPrototypeOf(obj, models.PolicyStatusQueryOperator.prototype);
                break;
            case "PolicySubClassificationQueryOperator":
                Object.setPrototypeOf(obj, models.PolicySubClassificationQueryOperator.prototype);
                break;
            case "PricingCategoryQueryOperator":
                Object.setPrototypeOf(obj, models.PricingCategoryQueryOperator.prototype);
                break;
            case "PricingPurchaseOptionQueryOperator":
                Object.setPrototypeOf(obj, models.PricingPurchaseOptionQueryOperator.prototype);
                break;
            case "ProductCategoryQueryOperator":
                Object.setPrototypeOf(obj, models.ProductCategoryQueryOperator.prototype);
                break;
            case "ProductCategoryRegexQueryOperator":
                Object.setPrototypeOf(obj, models.ProductCategoryRegexQueryOperator.prototype);
                break;
            case "ProductFamilyQueryOperator":
                Object.setPrototypeOf(obj, models.ProductFamilyQueryOperator.prototype);
                break;
            case "ProductServiceCodeQueryOperator":
                Object.setPrototypeOf(obj, models.ProductServiceCodeQueryOperator.prototype);
                break;
            case "ProductSkuQueryOperator":
                Object.setPrototypeOf(obj, models.ProductSkuQueryOperator.prototype);
                break;
            case "PromptAnalyticsLabelKeyValueQueryOperator":
                Object.setPrototypeOf(obj, models.PromptAnalyticsLabelKeyValueQueryOperator.prototype);
                break;
            case "PublisherQueryOperator":
                Object.setPrototypeOf(obj, models.PublisherQueryOperator.prototype);
                break;
            case "QueryOperatorBinary":
                Object.setPrototypeOf(obj, models.QueryOperatorBinary.prototype);
                break;
            case "QueryOperatorBinaryForGraph":
                Object.setPrototypeOf(obj, models.QueryOperatorBinaryForGraph.prototype);
                break;
            case "QueryOperatorBinaryLogic":
                Object.setPrototypeOf(obj, models.QueryOperatorBinaryLogic.prototype);
                break;
            case "QueryOperatorBinaryLogicForGraph":
                Object.setPrototypeOf(obj, models.QueryOperatorBinaryLogicForGraph.prototype);
                break;
            case "QueryOperatorComparator":
                Object.setPrototypeOf(obj, models.QueryOperatorComparator.prototype);
                break;
            case "QueryOperatorComparatorLogic":
                Object.setPrototypeOf(obj, models.QueryOperatorComparatorLogic.prototype);
                break;
            case "QueryOperatorFalse":
                Object.setPrototypeOf(obj, models.QueryOperatorFalse.prototype);
                break;
            case "QueryOperatorNary":
                Object.setPrototypeOf(obj, models.QueryOperatorNary.prototype);
                break;
            case "QueryOperatorNaryForGraph":
                Object.setPrototypeOf(obj, models.QueryOperatorNaryForGraph.prototype);
                break;
            case "QueryOperatorNaryLogic":
                Object.setPrototypeOf(obj, models.QueryOperatorNaryLogic.prototype);
                break;
            case "QueryOperatorNaryLogicForGraph":
                Object.setPrototypeOf(obj, models.QueryOperatorNaryLogicForGraph.prototype);
                break;
            case "QueryOperatorTrue":
                Object.setPrototypeOf(obj, models.QueryOperatorTrue.prototype);
                break;
            case "QueryOperatorUnary":
                Object.setPrototypeOf(obj, models.QueryOperatorUnary.prototype);
                break;
            case "QueryOperatorUnaryForGraph":
                Object.setPrototypeOf(obj, models.QueryOperatorUnaryForGraph.prototype);
                break;
            case "QueryOperatorUnaryNot":
                Object.setPrototypeOf(obj, models.QueryOperatorUnaryNot.prototype);
                break;
            case "QueryOperatorUnaryNotForGraph":
                Object.setPrototypeOf(obj, models.QueryOperatorUnaryNotForGraph.prototype);
                break;
            case "RecommendationSubClassificationQueryOperator":
                Object.setPrototypeOf(obj, models.RecommendationSubClassificationQueryOperator.prototype);
                break;
            case "ResourceCategoryQueryOperator":
                Object.setPrototypeOf(obj, models.ResourceCategoryQueryOperator.prototype);
                break;
            case "ResourceCategoryRegexQueryOperator":
                Object.setPrototypeOf(obj, models.ResourceCategoryRegexQueryOperator.prototype);
                break;
            case "ResourceGroupQueryOperator":
                Object.setPrototypeOf(obj, models.ResourceGroupQueryOperator.prototype);
                break;
            case "ResourceGroupRegexQueryOperator":
                Object.setPrototypeOf(obj, models.ResourceGroupRegexQueryOperator.prototype);
                break;
            case "ResourceIdQueryOperator":
                Object.setPrototypeOf(obj, models.ResourceIdQueryOperator.prototype);
                break;
            case "ResourceIdRegexQueryOperator":
                Object.setPrototypeOf(obj, models.ResourceIdRegexQueryOperator.prototype);
                break;
            case "ResourceInventoryAccount":
                Object.setPrototypeOf(obj, models.ResourceInventoryAccount.prototype);
                break;
            case "ResourceInventoryLocation":
                Object.setPrototypeOf(obj, models.ResourceInventoryLocation.prototype);
                break;
            case "ResourceInventoryProvider":
                Object.setPrototypeOf(obj, models.ResourceInventoryProvider.prototype);
                break;
            case "ResourceInventoryResourceText":
                Object.setPrototypeOf(obj, models.ResourceInventoryResourceText.prototype);
                break;
            case "ResourceInventoryTagged":
                Object.setPrototypeOf(obj, models.ResourceInventoryTagged.prototype);
                break;
            case "ResourceNameQueryOperator":
                Object.setPrototypeOf(obj, models.ResourceNameQueryOperator.prototype);
                break;
            case "ResourceNameRegexQueryOperator":
                Object.setPrototypeOf(obj, models.ResourceNameRegexQueryOperator.prototype);
                break;
            case "ResourceOperationQueryOperator":
                Object.setPrototypeOf(obj, models.ResourceOperationQueryOperator.prototype);
                break;
            case "ResourceOperationRegexQueryOperator":
                Object.setPrototypeOf(obj, models.ResourceOperationRegexQueryOperator.prototype);
                break;
            case "ResourceQueryCategory":
                Object.setPrototypeOf(obj, models.ResourceQueryCategory.prototype);
                break;
            case "ResourceQueryExtraKey":
                Object.setPrototypeOf(obj, models.ResourceQueryExtraKey.prototype);
                break;
            case "ResourceQueryExtraKeyValue":
                Object.setPrototypeOf(obj, models.ResourceQueryExtraKeyValue.prototype);
                break;
            case "ResourceQueryExtraPresence":
                Object.setPrototypeOf(obj, models.ResourceQueryExtraPresence.prototype);
                break;
            case "ResourceQueryFieldPresence":
                Object.setPrototypeOf(obj, models.ResourceQueryFieldPresence.prototype);
                break;
            case "ResourceQueryLocation":
                Object.setPrototypeOf(obj, models.ResourceQueryLocation.prototype);
                break;
            case "ResourceQueryResource":
                Object.setPrototypeOf(obj, models.ResourceQueryResource.prototype);
                break;
            case "ResourceQueryResourceGroup":
                Object.setPrototypeOf(obj, models.ResourceQueryResourceGroup.prototype);
                break;
            case "ResourceQueryResourceName":
                Object.setPrototypeOf(obj, models.ResourceQueryResourceName.prototype);
                break;
            case "ResourceQueryResourceType":
                Object.setPrototypeOf(obj, models.ResourceQueryResourceType.prototype);
                break;
            case "ResourceQueryTagKey":
                Object.setPrototypeOf(obj, models.ResourceQueryTagKey.prototype);
                break;
            case "ResourceQueryTagKeyKind":
                Object.setPrototypeOf(obj, models.ResourceQueryTagKeyKind.prototype);
                break;
            case "ResourceQueryTagKeyValue":
                Object.setPrototypeOf(obj, models.ResourceQueryTagKeyValue.prototype);
                break;
            case "ResourceQueryTagKeyValuesKind":
                Object.setPrototypeOf(obj, models.ResourceQueryTagKeyValuesKind.prototype);
                break;
            case "ResourceQueryTagPresence":
                Object.setPrototypeOf(obj, models.ResourceQueryTagPresence.prototype);
                break;
            case "ResourceTypeQueryOperator":
                Object.setPrototypeOf(obj, models.ResourceTypeQueryOperator.prototype);
                break;
            case "ScheduleQueryAssessmentAgentReportType":
                Object.setPrototypeOf(obj, models.ScheduleQueryAssessmentAgentReportType.prototype);
                break;
            case "ScheduleQueryCreatedBy":
                Object.setPrototypeOf(obj, models.ScheduleQueryCreatedBy.prototype);
                break;
            case "ScheduleQueryEmailRecipients":
                Object.setPrototypeOf(obj, models.ScheduleQueryEmailRecipients.prototype);
                break;
            case "ScheduleQueryIsActive":
                Object.setPrototypeOf(obj, models.ScheduleQueryIsActive.prototype);
                break;
            case "ScheduleQueryName":
                Object.setPrototypeOf(obj, models.ScheduleQueryName.prototype);
                break;
            case "ScheduleQueryNextGenReportType":
                Object.setPrototypeOf(obj, models.ScheduleQueryNextGenReportType.prototype);
                break;
            case "ScheduleQueryPolicyId":
                Object.setPrototypeOf(obj, models.ScheduleQueryPolicyId.prototype);
                break;
            case "ScheduleQueryRecurrence":
                Object.setPrototypeOf(obj, models.ScheduleQueryRecurrence.prototype);
                break;
            case "ScheduleQueryReportType":
                Object.setPrototypeOf(obj, models.ScheduleQueryReportType.prototype);
                break;
            case "ScheduleQueryResource":
                Object.setPrototypeOf(obj, models.ScheduleQueryResource.prototype);
                break;
            case "ScopeContainsServiceAccountQueryOperator":
                Object.setPrototypeOf(obj, models.ScopeContainsServiceAccountQueryOperator.prototype);
                break;
            case "ScopeContainsTenantQueryOperator":
                Object.setPrototypeOf(obj, models.ScopeContainsTenantQueryOperator.prototype);
                break;
            case "ScopeIsQueryOperator":
                Object.setPrototypeOf(obj, models.ScopeIsQueryOperator.prototype);
                break;
            case "SecopsVulnerabilitySeverityQueryOperator":
                Object.setPrototypeOf(obj, models.SecopsVulnerabilitySeverityQueryOperator.prototype);
                break;
            case "ServiceAccountNameRegexQueryOperator":
                Object.setPrototypeOf(obj, models.ServiceAccountNameRegexQueryOperator.prototype);
                break;
            case "ServiceAccountNativeDetailsQueryOperator":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsQueryOperator.prototype);
                break;
            case "ServiceAccountQueryOperator":
                Object.setPrototypeOf(obj, models.ServiceAccountQueryOperator.prototype);
                break;
            case "ServiceAccountStatusQueryOperator":
                Object.setPrototypeOf(obj, models.ServiceAccountStatusQueryOperator.prototype);
                break;
            case "ServiceAccountTagKeyQueryOperator":
                Object.setPrototypeOf(obj, models.ServiceAccountTagKeyQueryOperator.prototype);
                break;
            case "ServiceAccountTagKeyRegexQueryOperator":
                Object.setPrototypeOf(obj, models.ServiceAccountTagKeyRegexQueryOperator.prototype);
                break;
            case "ServiceAccountTagKeyValueQueryOperator":
                Object.setPrototypeOf(obj, models.ServiceAccountTagKeyValueQueryOperator.prototype);
                break;
            case "ServiceCategoryQueryOperator":
                Object.setPrototypeOf(obj, models.ServiceCategoryQueryOperator.prototype);
                break;
            case "ServiceNowCmdbQuerySyncLogAction":
                Object.setPrototypeOf(obj, models.ServiceNowCmdbQuerySyncLogAction.prototype);
                break;
            case "ServiceNowCmdbQuerySyncLogResourceId":
                Object.setPrototypeOf(obj, models.ServiceNowCmdbQuerySyncLogResourceId.prototype);
                break;
            case "ServiceNowCmdbQuerySyncLogResourceType":
                Object.setPrototypeOf(obj, models.ServiceNowCmdbQuerySyncLogResourceType.prototype);
                break;
            case "ServiceNowCmdbQuerySyncLogService":
                Object.setPrototypeOf(obj, models.ServiceNowCmdbQuerySyncLogService.prototype);
                break;
            case "ServiceNowCmdbQuerySyncLogStatus":
                Object.setPrototypeOf(obj, models.ServiceNowCmdbQuerySyncLogStatus.prototype);
                break;
            case "ServiceTypeQueryOperator":
                Object.setPrototypeOf(obj, models.ServiceTypeQueryOperator.prototype);
                break;
            case "TagKeyRegexQueryOperator":
                Object.setPrototypeOf(obj, models.TagKeyRegexQueryOperator.prototype);
                break;
            case "TagKeyStringValueRegexQueryOperator":
                Object.setPrototypeOf(obj, models.TagKeyStringValueRegexQueryOperator.prototype);
                break;
            case "TagKeyValueRegexQueryOperator":
                Object.setPrototypeOf(obj, models.TagKeyValueRegexQueryOperator.prototype);
                break;
            case "TagKindStringKeyRegexQueryOperator":
                Object.setPrototypeOf(obj, models.TagKindStringKeyRegexQueryOperator.prototype);
                break;
            case "TemplateJobArchivedQueryOperator":
                Object.setPrototypeOf(obj, models.TemplateJobArchivedQueryOperator.prototype);
                break;
            case "TemplateJobEngineTypeQueryOperator":
                Object.setPrototypeOf(obj, models.TemplateJobEngineTypeQueryOperator.prototype);
                break;
            case "TemplateJobExecutionTypeQueryOperator":
                Object.setPrototypeOf(obj, models.TemplateJobExecutionTypeQueryOperator.prototype);
                break;
            case "TemplateJobFromDateQueryOperator":
                Object.setPrototypeOf(obj, models.TemplateJobFromDateQueryOperator.prototype);
                break;
            case "TemplateJobServiceAccountQueryOperator":
                Object.setPrototypeOf(obj, models.TemplateJobServiceAccountQueryOperator.prototype);
                break;
            case "TemplateJobStatusQueryOperator":
                Object.setPrototypeOf(obj, models.TemplateJobStatusQueryOperator.prototype);
                break;
            case "TemplateJobTemplateIdQueryOperator":
                Object.setPrototypeOf(obj, models.TemplateJobTemplateIdQueryOperator.prototype);
                break;
            case "TemplateJobToDateQueryOperator":
                Object.setPrototypeOf(obj, models.TemplateJobToDateQueryOperator.prototype);
                break;
            case "TenantNameRegexQueryOperator":
                Object.setPrototypeOf(obj, models.TenantNameRegexQueryOperator.prototype);
                break;
            case "TenantQueryOperator":
                Object.setPrototypeOf(obj, models.TenantQueryOperator.prototype);
                break;
            case "TenantTagKeyQueryOperator":
                Object.setPrototypeOf(obj, models.TenantTagKeyQueryOperator.prototype);
                break;
            case "TenantTagKeyValueQueryOperator":
                Object.setPrototypeOf(obj, models.TenantTagKeyValueQueryOperator.prototype);
                break;
            case "ThreatHasTicketQueryOperator":
                Object.setPrototypeOf(obj, models.ThreatHasTicketQueryOperator.prototype);
                break;
            case "ThreatIntentQueryOperator":
                Object.setPrototypeOf(obj, models.ThreatIntentQueryOperator.prototype);
                break;
            case "ThreatVulnerabilityIssueTypeQueryOperator":
                Object.setPrototypeOf(obj, models.ThreatVulnerabilityIssueTypeQueryOperator.prototype);
                break;
            case "ThreatVulnerabilitySeverityQueryOperator":
                Object.setPrototypeOf(obj, models.ThreatVulnerabilitySeverityQueryOperator.prototype);
                break;
            case "ThreatVulnerabilityStatusQueryOperator":
                Object.setPrototypeOf(obj, models.ThreatVulnerabilityStatusQueryOperator.prototype);
                break;
            case "UniqueIdQueryOperator":
                Object.setPrototypeOf(obj, models.UniqueIdQueryOperator.prototype);
                break;
            case "UtilizationTypeQueryOperator":
                Object.setPrototypeOf(obj, models.UtilizationTypeQueryOperator.prototype);
                break;
            case "VmAgentsQueryCrowdStrikeStatus":
                Object.setPrototypeOf(obj, models.VmAgentsQueryCrowdStrikeStatus.prototype);
                break;
            case "VmAgentsQueryInstantState":
                Object.setPrototypeOf(obj, models.VmAgentsQueryInstantState.prototype);
                break;
            case "VmAgentsQueryOsTypes":
                Object.setPrototypeOf(obj, models.VmAgentsQueryOsTypes.prototype);
                break;
            case "VmAgentsQueryQualysStatus":
                Object.setPrototypeOf(obj, models.VmAgentsQueryQualysStatus.prototype);
                break;
            case "VmAgentsQuerySplunkStatus":
                Object.setPrototypeOf(obj, models.VmAgentsQuerySplunkStatus.prototype);
                break;
            case "VulnerabilityReferenceIdQueryOperator":
                Object.setPrototypeOf(obj, models.VulnerabilityReferenceIdQueryOperator.prototype);
                break;
            case "WorkFlowIdQueryOperator":
                Object.setPrototypeOf(obj, models.WorkFlowIdQueryOperator.prototype);
                break;
            case "WorkloadQueryCloud":
                Object.setPrototypeOf(obj, models.WorkloadQueryCloud.prototype);
                break;
            case "WorkloadQueryCloudAccount":
                Object.setPrototypeOf(obj, models.WorkloadQueryCloudAccount.prototype);
                break;
            case "WorkloadQueryWorkloadId":
                Object.setPrototypeOf(obj, models.WorkloadQueryWorkloadId.prototype);
                break;
            case "WorkloadQueryWorkloadName":
                Object.setPrototypeOf(obj, models.WorkloadQueryWorkloadName.prototype);
                break;
            case "WorkloadQueryWorkloadOwner":
                Object.setPrototypeOf(obj, models.WorkloadQueryWorkloadOwner.prototype);
                break;
            case "WorkloadQueryWorkloadType":
                Object.setPrototypeOf(obj, models.WorkloadQueryWorkloadType.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof QueryOperator)[] {
        return [
            models.AIAgentAttributesQueryOperator,
            models.AIProviderQueryOperator,
            models.AppSecopsApplicationIdQueryOperator,
            models.AppSecopsComponentProductQueryOperator,
            models.AppSecopsContainerFindingsCategoryQueryOperator,
            models.AppSecopsContainerFindingsExecutionPhaseQueryOperator,
            models.AppSecopsContainerFindingsSBOMVersionIdsQueryOperator,
            models.AppSecopsContainerFindingsSeverityQueryOperator,
            models.AppSecopsContainerFindingsStatusQueryOperator,
            models.AppSecopsCveIdQueryOperator,
            models.AppSecopsCvssScoreQueryOperator,
            models.AppSecopsEpssScoreQueryOperator,
            models.AppSecopsFixAvailableQueryOperator,
            models.AppSecopsGraphionScoreQueryOperator,
            models.AppSecopsIsKnownExploitedVulnerabilityQueryOperator,
            models.AppSecopsPortfolioIdQueryOperator,
            models.AppSecopsProjectIdQueryOperator,
            models.AppSecopsSbomComponentIdQueryOperator,
            models.AppSecopsSbomComponentTypeQueryOperator,
            models.AppSecopsSbomNameQueryOperator,
            models.AppSecopsSbomVersionBuildIdQueryOperator,
            models.AppSecopsSbomVersionIdQueryOperator,
            models.AppSecopsSbomVersionSubmittedByQueryOperator,
            models.AppSecopsSbomVersionSubmittedDateQueryOperator,
            models.AppSecopsVulnerabilityExploitabilityMetricAttackComplexityV31QueryOperator,
            models.AppSecopsVulnerabilityExploitabilityMetricAttackVectorV31QueryOperator,
            models.AppSecopsVulnerabilityExploitabilityMetricPrivilegesRequiredV31QueryOperator,
            models.AppSecopsVulnerabilityExploitabilityMetricScopeV31QueryOperator,
            models.AppSecopsVulnerabilityExploitabilityUserInteractionV31QueryOperator,
            models.AppSecopsVulnerabilityImpactMetricAvailabilityImpactV31QueryOperator,
            models.AppSecopsVulnerabilityImpactMetricConfidentialityImpactV31QueryOperator,
            models.AppSecopsVulnerabilityImpactMetricIntegrityImpactV31QueryOperator,
            models.ApplicableHealthMetricsQueryOperator,
            models.AssessmentQueryAssessmentApprover,
            models.AssessmentQueryAssessmentName,
            models.AssessmentQueryAssessmentOwner,
            models.AssessmentQueryFramework,
            models.AssessmentQueryPillar,
            models.AssessmentQueryWorkload,
            models.AssessmentReportQueryAssessmentName,
            models.AssessmentReportQueryFramework,
            models.AssessmentReportQueryReportType,
            models.AssessmentReportQueryWorkloadId,
            models.AssessmentRunReportDetailQuerySection,
            models.AssessmentRunReportSummaryQuerySection,
            models.AssessmentViewQueryAssignedTo,
            models.AssessmentViewQueryBestPracticeRisk,
            models.AssessmentViewQueryBestPracticeStatus,
            models.AssessmentViewQueryComment,
            models.AssessmentViewQueryNature,
            models.AssessmentViewQueryOwner,
            models.AssessmentViewQueryQuestionRisk,
            models.AssessmentViewQueryQuestionStatus,
            models.AutomationTemplateQueryClassification,
            models.AutomationTemplateQueryEngineType,
            models.AutomationTemplateQueryEngineTypes,
            models.AutomationTemplateQueryProvider,
            models.AutomationTemplateQueryRepoType,
            models.AutomationTemplateQueryResourceType,
            models.AutomationTemplateQueryScope,
            models.AutomationTemplateQueryService,
            models.AutomationTemplateQuerySubClassification,
            models.AutomationTemplateQueryTemplateType,
            models.AutomationTemplateQueryTenant,
            models.AvailabilityZoneQueryOperator,
            models.AwsSecurityHubFindingQueryCloudAccount,
            models.AwsSecurityHubFindingQueryLocation,
            models.AwsSecurityHubFindingQueryProductName,
            models.AwsSecurityHubFindingQueryRecordState,
            models.AwsSecurityHubFindingQueryResource,
            models.AwsSecurityHubFindingQuerySeverity,
            models.AwsSsmDocumentQueryCategory,
            models.AwsSsmDocumentQueryCloudAccount,
            models.AwsSsmDocumentQueryExecutedBy,
            models.AwsSsmDocumentQueryName,
            models.AwsSsmDocumentQueryOwner,
            models.AwsSsmDocumentQueryRegion,
            models.AwsSsmDocumentQueryStatus,
            models.BillingEntityQueryOperator,
            models.BillingEntityRegexQueryOperator,
            models.BillingLineItemTypeQueryOperator,
            models.BillingLineItemTypeRegexQueryOperator,
            models.BillingSourceQueryOperator,
            models.CompartmentNameQueryOperator,
            models.CompartmentPathQueryOperator,
            models.ComplianceAssessmentDetailStatusQueryOperator,
            models.ComplianceAssessmentHistoryExecutionTypeQueryOperator,
            models.ComplianceAssessmentHistoryStatusQueryOperator,
            models.ComplianceControlFamilyQueryOperator,
            models.ComplianceControlNatureQueryOperator,
            models.ComplianceControlPolicyUris,
            models.ComplianceControlSeverityQueryOperator,
            models.ComplianceControlSubFamilyQueryOperator,
            models.ComplianceStandardIDQueryOperator,
            models.ComplianceStandardScopeQueryOperator,
            models.ComplianceURIQueryOperator,
            models.ContainerIdRegexQueryOperator,
            models.CostAnomalyStatusQueryOperator,
            models.CurrencyExchangeConfigurationQueryScope,
            models.CurrencyExchangeConfigurationQuerySourceCurrency,
            models.CurrencyExchangeConfigurationQueryTargetCurrency,
            models.CurrencyQueryOperator,
            models.CvssMetricScoreRangeQueryOperator,
            models.DescendantServiceAccountInTenantQueryOperator,
            models.DescendantServiceAccountQueryOperator,
            models.DimensionQueryOperator,
            models.DimensionSourceQueryOperator,
            models.DurationInMonthsQueryOperator,
            models.EpssScoreRangeQueryOperator,
            models.EventCreationTimeRangeQueryOperator,
            models.ExtrasValueRegexQueryOperator,
            models.GraphionScoreRangeQueryOperator,
            models.InfraResourceTrendResourceChangeStatusQueryOperator,
            models.InfraVulnerabilityAWSInspectorEcrImageArchitectureQueryOperator,
            models.InfraVulnerabilityAWSInspectorEcrImageHashQueryOperator,
            models.InfraVulnerabilityAWSInspectorEcrImageRepositoryNameQueryOperator,
            models.InfraVulnerabilityAWSInspectorEcrImageTagsQueryOperator,
            models.InfraVulnerabilityAWSInspectorExploitAvailableQueryOperator,
            models.InfraVulnerabilityAWSInspectorFixAvailableQueryOperator,
            models.InfraVulnerabilityAWSInspectorLambdaArchitectureQueryOperator,
            models.InfraVulnerabilityAWSInspectorLambdaFunctionNameQueryOperator,
            models.InfraVulnerabilityAWSInspectorLambdaRuntimeQueryOperator,
            models.InfraVulnerabilityFindingsTypeQueryOperator,
            models.InfraVulnerabilitySourceQueryOperator,
            models.IsSystemPolicyQueryOperator,
            models.LineItemDescriptionQueryOperator,
            models.LineItemDescriptionRegexQueryOperator,
            models.LocationQueryOperator,
            models.MasterAccountBillingQueryConversations,
            models.MasterAccountBillingQueryMasterAccounts,
            models.MasterAccountBillingQueryTenants,
            models.MasterAccountBillingQueryTransactionType,
            models.MasterAccountBillingQueryUsers,
            models.MeterSubCategoryQueryOperator,
            models.MetricNameQueryOperator,
            models.MetricValuesOperator,
            models.ModelNameQueryOperator,
            models.PatchReadinessStatusQueryOperator,
            models.PlatFormAccountQueryOperator,
            models.PodIdRegexQueryOperator,
            models.PodIdsQueryOperator,
            models.PodNameRegexQueryOperator,
            models.PodNamesQueryOperator,
            models.PolicyCategoryQueryOperator,
            models.PolicyClassificationQueryOperator,
            models.PolicyEngineTypeQueryOperator,
            models.PolicyJobCloudProviderQueryOperator,
            models.PolicyJobCreatedAtQueryOperator,
            models.PolicyJobEngineTypeQueryOperator,
            models.PolicyJobExecutionGroupQueryOperator,
            models.PolicyJobExecutionTypeQueryOperator,
            models.PolicyJobIsArchivedQueryOperator,
            models.PolicyJobPolicyIdQueryOperator,
            models.PolicyJobStatusQueryOperator,
            models.PolicyJobViolatedQueryOperator,
            models.PolicyParameterConfiguredQueryOperator,
            models.PolicyParameterQueryOperator,
            models.PolicyRecommendationClassificationQueryOperator,
            models.PolicyRecommendationSourceQueryOperator,
            models.PolicyRemediationActionEnabledQueryOperator,
            models.PolicyResourceRecommendationPolicyIdsQueryOperator,
            models.PolicyResourceRecommendationSeverityQueryOperator,
            models.PolicyResourceRecommendationStatusQueryOperator,
            models.PolicyScopeQueryOperator,
            models.PolicyServiceQueryOperator,
            models.PolicySeverityQueryOperator,
            models.PolicyStatusQueryOperator,
            models.PolicySubClassificationQueryOperator,
            models.PricingCategoryQueryOperator,
            models.PricingPurchaseOptionQueryOperator,
            models.ProductCategoryQueryOperator,
            models.ProductCategoryRegexQueryOperator,
            models.ProductFamilyQueryOperator,
            models.ProductServiceCodeQueryOperator,
            models.ProductSkuQueryOperator,
            models.PromptAnalyticsLabelKeyValueQueryOperator,
            models.PublisherQueryOperator,
            models.QueryOperatorBinary,
            models.QueryOperatorBinaryForGraph,
            models.QueryOperatorBinaryLogic,
            models.QueryOperatorBinaryLogicForGraph,
            models.QueryOperatorComparator,
            models.QueryOperatorComparatorLogic,
            models.QueryOperatorFalse,
            models.QueryOperatorNary,
            models.QueryOperatorNaryForGraph,
            models.QueryOperatorNaryLogic,
            models.QueryOperatorNaryLogicForGraph,
            models.QueryOperatorTrue,
            models.QueryOperatorUnary,
            models.QueryOperatorUnaryForGraph,
            models.QueryOperatorUnaryNot,
            models.QueryOperatorUnaryNotForGraph,
            models.RecommendationSubClassificationQueryOperator,
            models.ResourceCategoryQueryOperator,
            models.ResourceCategoryRegexQueryOperator,
            models.ResourceGroupQueryOperator,
            models.ResourceGroupRegexQueryOperator,
            models.ResourceIdQueryOperator,
            models.ResourceIdRegexQueryOperator,
            models.ResourceInventoryAccount,
            models.ResourceInventoryLocation,
            models.ResourceInventoryProvider,
            models.ResourceInventoryResourceText,
            models.ResourceInventoryTagged,
            models.ResourceNameQueryOperator,
            models.ResourceNameRegexQueryOperator,
            models.ResourceOperationQueryOperator,
            models.ResourceOperationRegexQueryOperator,
            models.ResourceQueryCategory,
            models.ResourceQueryExtraKey,
            models.ResourceQueryExtraKeyValue,
            models.ResourceQueryExtraPresence,
            models.ResourceQueryFieldPresence,
            models.ResourceQueryLocation,
            models.ResourceQueryResource,
            models.ResourceQueryResourceGroup,
            models.ResourceQueryResourceName,
            models.ResourceQueryResourceType,
            models.ResourceQueryTagKey,
            models.ResourceQueryTagKeyKind,
            models.ResourceQueryTagKeyValue,
            models.ResourceQueryTagKeyValuesKind,
            models.ResourceQueryTagPresence,
            models.ResourceTypeQueryOperator,
            models.ScheduleQueryAssessmentAgentReportType,
            models.ScheduleQueryCreatedBy,
            models.ScheduleQueryEmailRecipients,
            models.ScheduleQueryIsActive,
            models.ScheduleQueryName,
            models.ScheduleQueryNextGenReportType,
            models.ScheduleQueryPolicyId,
            models.ScheduleQueryRecurrence,
            models.ScheduleQueryReportType,
            models.ScheduleQueryResource,
            models.ScopeContainsServiceAccountQueryOperator,
            models.ScopeContainsTenantQueryOperator,
            models.ScopeIsQueryOperator,
            models.SecopsVulnerabilitySeverityQueryOperator,
            models.ServiceAccountNameRegexQueryOperator,
            models.ServiceAccountNativeDetailsQueryOperator,
            models.ServiceAccountQueryOperator,
            models.ServiceAccountStatusQueryOperator,
            models.ServiceAccountTagKeyQueryOperator,
            models.ServiceAccountTagKeyRegexQueryOperator,
            models.ServiceAccountTagKeyValueQueryOperator,
            models.ServiceCategoryQueryOperator,
            models.ServiceNowCmdbQuerySyncLogAction,
            models.ServiceNowCmdbQuerySyncLogResourceId,
            models.ServiceNowCmdbQuerySyncLogResourceType,
            models.ServiceNowCmdbQuerySyncLogService,
            models.ServiceNowCmdbQuerySyncLogStatus,
            models.ServiceTypeQueryOperator,
            models.TagKeyRegexQueryOperator,
            models.TagKeyStringValueRegexQueryOperator,
            models.TagKeyValueRegexQueryOperator,
            models.TagKindStringKeyRegexQueryOperator,
            models.TemplateJobArchivedQueryOperator,
            models.TemplateJobEngineTypeQueryOperator,
            models.TemplateJobExecutionTypeQueryOperator,
            models.TemplateJobFromDateQueryOperator,
            models.TemplateJobServiceAccountQueryOperator,
            models.TemplateJobStatusQueryOperator,
            models.TemplateJobTemplateIdQueryOperator,
            models.TemplateJobToDateQueryOperator,
            models.TenantNameRegexQueryOperator,
            models.TenantQueryOperator,
            models.TenantTagKeyQueryOperator,
            models.TenantTagKeyValueQueryOperator,
            models.ThreatHasTicketQueryOperator,
            models.ThreatIntentQueryOperator,
            models.ThreatVulnerabilityIssueTypeQueryOperator,
            models.ThreatVulnerabilitySeverityQueryOperator,
            models.ThreatVulnerabilityStatusQueryOperator,
            models.UniqueIdQueryOperator,
            models.UtilizationTypeQueryOperator,
            models.VmAgentsQueryCrowdStrikeStatus,
            models.VmAgentsQueryInstantState,
            models.VmAgentsQueryOsTypes,
            models.VmAgentsQueryQualysStatus,
            models.VmAgentsQuerySplunkStatus,
            models.VulnerabilityReferenceIdQueryOperator,
            models.WorkFlowIdQueryOperator,
            models.WorkloadQueryCloud,
            models.WorkloadQueryCloudAccount,
            models.WorkloadQueryWorkloadId,
            models.WorkloadQueryWorkloadName,
            models.WorkloadQueryWorkloadOwner,
            models.WorkloadQueryWorkloadType,
        ];
    }

    fixupFields() {
    }

}
